import React from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_sound-equipment-rent/artifacts/yvl1195g_62c007ad-422b-416c-8221-a455d45a63e6.jpg';

// Display the customer-provided logo with the lettering rendered in black
// on a transparent/light background. We invert the original (which has dark
// lettering on black bg), then push contrast hard so the lettering becomes
// near-pure black and the formerly-black background becomes pure white.
// We then use mix-blend-mode: multiply so the white area disappears on the
// site's white navbar — leaving only the crisp black logo visible.
const Logo = ({ size = 'md' }) => {
  const sizes = {
    sm: 'h-24',
    md: 'h-40',
    lg: 'h-56',
  };
  const heightClass = sizes[size] || sizes.md;

  return (
    <img
      src={LOGO_URL}
      alt="Betti SRL — Audio Lights Video"
      className={`${heightClass} w-auto object-contain`}
      style={{
        filter: 'invert(1) brightness(0.55) contrast(10)',
        mixBlendMode: 'multiply',
      }}
      loading="eager"
    />
  );
};

export default Logo;
